import _ from 'lodash';
import  { useContext, useEffect, useRef, useState } from 'react';
import { faSync } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ApplicableTableSettings, codesVesselNameList } from '../../../../tableSettings';

import useFastStorage, { useTypedFastStorage } from '../../../../hooks/useFastStorage';
import useFunction from '../../../../hooks/useFunction';
import useGlobalOkDialog from '../../../../hooks/useGlobalOkDialog';
import ApplicationContext from '../../../../ApplicationContext';
import { Search, isFilterObjectEmpty, getInitialSearch } from '../../../../filtering';
import { Portal } from 'react-portal';
import { CodeVesselListItem } from '../../../../fms.data/models/CodeVesselListItem';
import { JobNames } from '../../../../framework.core/JobNames';
import { ApiResult, InsertResult } from '../../../../framework.core/data/ApiResult';
import { SQLType } from '../../../../framework.core/data/SQLInfo';
import { FmsSecTask } from '../../../../fms.core/constants';
import GreenButton from '../../../../ui/GreenButton';
import TextBox from '../../../../ui/TextBox';
import EditableTable, { CellData, TableCellAligns, TableCellTypes } from '../../../../ui/tables/editing/EditableTable';
import { checkTabIsDirty, sortingListData } from '../../ReferenceFiles';
import { duplicateCell, findSecurityTask } from '../../../../util';
import useFilterBar from '../../../../hooks/useFilterBar';
import { ListOrderBy } from "../../../common/AbstractListView";

import BlackInverseButton from '../../../../ui/BlackInverseButton';
import constants from '../../../../constants';
import IFmsReferenceFilesContext from '../../IfmsReferenceFilesContext';
import CloseButton from '../../../../ui/CloseButton';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';
import { RefreshIconButton2 } from '../../../../ui/IconButton';

class EditableVesselName extends CodeVesselListItem {
  isNew: boolean = false;
  isDelete: boolean = false;
  isUpdate: boolean = false;
  tested: boolean = false;
}

function VesselNameRenderer({data, row, cell}:any) {

  const changeLineItem = data[0].changeLineItem;
  const l = data[row.index];

  return (
    <TextBox
      maxLength={50}
      textId={`ifms-vesselname-name-${row.index}`}
      value={l.vesselName}
      onChange={(e) => {
        changeLineItem(row.index, { vesselName: e.target.value, isUpdate: true, tested: false });
      }}
    />
  );
}


function CountryRenderer({data, row, cell}:any) {
  const changeLineItem = data[0].changeLineItem;
  const l = data[row.index];
  return (
    <div style={{marginTop: '0px'}}>
      <TextBox maxLength={2} textId="ifms-sdk-country" value={l.country} onChange={(e) => {
        changeLineItem(row.index, {country: e.target.value, isUpdate:true });
        
        }} />
    </div>
  );
}

function VesselFlagRenderer({data, row, cell}:any) {
  const changeLineItem = data[0].changeLineItem;  
  const l = data[row.index];
  return (
    <div style={{marginTop: '0px'}}>
      <TextBox maxLength={2} textId="ifms-sdk-vessel-flag" value={l.vesselFlag} onChange={(e) => {
          changeLineItem(row.index, {vesselFlag: e.target.value, isUpdate:true });
        }} />
    </div>
  );
}

function LloydsRenderer({data, row, cell}:any) {
  const changeLineItem = data[0].changeLineItem;
  const l = data[row.index];
  return (
    <div style={{marginTop: '0px'}}>
      <TextBox maxLength={7} textId="ifms-sdk-lloyds" value={l.lloydsCode} onChange={(e) => {
       changeLineItem(row.index, {lloydsCode: e.target.value, isUpdate:true });
        }} />
    </div>
  );
}

function GroupRenderer({data, row, cell}:any) {
  const changeLineItem = data[0].changeLineItem;
  const l = data[row.index];
  return (
    <div style={{marginTop: '0px'}}>
      <TextBox maxLength={7} textId="ifms-sdk-group" value={l.groupName} onChange={(e) => {
       changeLineItem(row.index, {groupName: e.target.value, isUpdate:true });
        }} />
    </div>
  );
}

function formatElement(data:any) {
  const result = new EditableVesselName();
  result.vesselName = data.vesselName;
  result.country = data.country;
  result.vesselFlag = data.vesselFlag;
  result.lloydsCode = data.lloydsCode;
  result.groupName = data.groupName;
  result.cid = data.cid;
  result.isNew = false;
  result.isDelete = false;

  return result;
}

function formatData(data: Array<any>) {
  return data.map(d => formatElement(d));
}

function VesselNameComponent({
  componentIndex
}: {
  componentIndex: number
}) {
  useFunction({
    invokers: {
      ifmsReferenceFilesSave: save,
      ifmsReferenceFilesCancel: cancelOperation,
    }
  });
  useFunctionKeys({ onSave: handleSaveAndClose });

  const appContext = useContext(ApplicationContext);
  const refContext = useContext(IFmsReferenceFilesContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  //const { selectTableRow } = useTableNavigation('codes-vessel-name-list', undefined, undefined, [], false, true, true);

  const [loading, setLoading] = useState(false);
  const [hasChanges, setHasChanges] = useFastStorage(`ifms-referenceFiles-haschanges`, false);
  const [data, _setData, removeData, dataRef] = useFastStorage(`ifms-referenceFiles-vessel-name-list`, []);

  const savedDataRef = useRef<Array<CodeVesselListItem>>([]);
  const oriData = useRef<CodeVesselListItem[]>([]);
  const [orderBy, setOrderBy] = useTypedFastStorage<ListOrderBy>(`ifms-referenceFiles-vessel-name-orderby`, getDefaultOrderBy());

  const listSec = findSecurityTask(appContext, FmsSecTask.CodeVessel);
  const tableHeight = 520;
  const listItemType = 'CodeVesselListItem';

  const [focusFirstCell, setFocusFirstCell] = useState({ dataLength: 0, focus: false });
  const { FilterButton, search } = useFilterBar(
    codesVesselNameList,
    undefined,
    getDefaultOrderBy(),
    String(componentIndex),
    false,
    undefined,
    undefined,
    setOrderBy,
  );

  function handleSaveAndClose() {
    const saveBtn = document.getElementById('detail-save-button');
    if (saveBtn) {
      saveBtn.focus();
      const modals = document.querySelector('[class^="ReactModal__Content"]');
      if (!modals)
        saveBtn.click();
    }
  }

  function getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'vesselName',
      orderByAscending: true,
    };
  }

  function setData(d: any, callByFetchData: boolean = false) {
    setFocusFirstCell({ dataLength: d.length, focus: callByFetchData });
    _setData(d, null, { forceClone: callByFetchData });
    setHasChanges(checkTabIsDirty(CodeVesselListItem, oriData.current, d));
  }

  async function fetchData(api: any, clearHeaderOrder: boolean) {
    if (clearHeaderOrder && isFilterObjectEmpty(search)) {
      setOrderBy(getDefaultOrderBy());
    } else if (search.orderBy) {
      setOrderBy({ orderBy: search.orderBy, orderByAscending: search.orderByAscending });
    }

    setLoading(true);

    const searchModel = CodeVesselListItem.calculateSearchParameters(search);
    const apiResult = await api.getListItems(JobNames.Vessel,
      listItemType,
      searchModel, 1, search.pageSize);
    const data = apiResult && apiResult.entities ? apiResult.entities : [];

    setData(formatData(data), true);

    setFocusFirstCell({ dataLength: data.length, focus: false });
    setLoading(false);
    setHasChanges(false);
  }

  useEffect(() => {
    if (isFilterObjectEmpty(search) && search.version === 1) reload(false);
    
    return () => {
      removeData();
    };
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    if (loading || (isFilterObjectEmpty(search) && search.version === 1)) {
      return;
    }
    fetchData(appContext.api, isFilterObjectEmpty(search));
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [search]
  );

  useEffect(() => {
    if (dataRef.current?.length > 0 && !loading) {
      //selectTableRow(0);
      oriData.current = _.cloneDeep(data);
      savedDataRef.current = _.cloneDeep(data);
    }
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loading]
  );

  async function reload(clearAll:boolean = true) {
    await fetchData(appContext.api, clearAll);
  }

  function onHeaderClick(header: any) {
    if (!orderBy || !orderBy.orderBy) return;

    if (header && header.id !== 'indicator') {
      if (header.id === orderBy.orderBy) {
        setOrderBy({ orderByAscending: !orderBy.orderByAscending });
      } else {
        setOrderBy({ orderBy: header.id, orderByAscending: true });
      }
      
      removeData();
      sortingListData(CodeVesselListItem, data, setData, orderBy);
    }
  }

  function addLineItem() {
    let newrow = new EditableVesselName();
    newrow.isNew = true;

    return {
      setDataFunc: (list: any) => setData(list),
      curListData: data,
      newData: newrow
    };
  }

  async function cancelOperation(){
    setHasChanges(false);
    removeData();
    return true;
  }

  function applyToLineItem(rowIndex: number, change: Partial<EditableVesselName>|null) {
    if (!change || !data) {
      return;
    }
    const checkData = data[rowIndex];
    if (!change.isNew && (change.vesselName !== checkData.vesselName || change.country !== checkData.country
      || change.vesselFlag !== checkData.vesselFlag|| change.lloydsCode !== checkData.lloydsCode|| change.groupName !== checkData.groupName)) {
    _.merge(data[rowIndex], {...change, hasBeenChanged: true});
    setData(data);
    }
    return true;
  }

  function deleteEntity(rowIndex: number): boolean {
    if (!data) {
      return false;
    }

    const element = data[rowIndex];
    if (!element.isNew) {
      let deleteRow = savedDataRef.current.find(x => x.vesselName === element.vesselName);
      if (deleteRow) {
        deleteRow.isDelete = true;
      }
    }
    data.splice(rowIndex, 1);
    setData(data);
    return true;
  }

  async function save() {
    if (!data) {
      return;
    }

    let validData = dataRef.current.filter((x:any) => x.vesselName);

    let errMsg = '';
    const dataToSave = validData.filter((x: any) => x.id <= 0 || x.hasBeenChanged === true); // new data is always last so index check works
    const dataToDelete = savedDataRef.current.filter((x) => x.isDelete);
    if(dataToSave.length === 0 && dataToDelete.length === 0) {
      if (hasChanges) reload(false);
      return;
    }
    setLoading(true);

    for (let i = 0; i < dataToDelete.length; ++i) {
      const s = dataToDelete[i];
      const apiResult: ApiResult<InsertResult> = await appContext.api.saveListItem(listItemType,
        SQLType.Delete,
        _.omit(s, ['isDelete']));

      if (!apiResult || !apiResult.success)
        errMsg = apiResult.message?? constants.SAVE_ERROR_MESSAGE;
    }

    if (dataToSave.length > 0) {
      const isDuplicate = await duplicateCell(dataToSave, data, appContext, listItemType, showGlobalOkDialog, JobNames.Vessel, 'vesselName');
      if(isDuplicate){
        setLoading(false);
        return;
      }
      const cidData = dataToSave.map((a: CodeVesselListItem) => a.cid?.toLowerCase()) as Array<String>;

      const secondSave = dataToSave.filter((x: CodeVesselListItem) => cidData.includes(x.vesselName.toLowerCase()));
      const firstSave = dataToSave.filter((x: CodeVesselListItem) => !secondSave.includes(x));

      if (firstSave.length > 0) {
        const apiResult: ApiResult<InsertResult> = await appContext.api.saveList(listItemType, firstSave);
        if (!apiResult || !apiResult.success)
          errMsg += (errMsg ? '\n' : '') + (apiResult?.message ?? constants.SAVE_ERROR_MESSAGE );
        else {
          firstSave.forEach((x: any) => {
            const index = data.findIndex((d: any) => d.vesselName === x.vesselName);
            if (index >= 0) {
              data[index].cid = x.vesselName;
              data[index].hasBeenChanged = false;
            }
            if (x.isNew) {
              x.isNew = false;
              //delete data[index].isNew;
            }
          })
        }
      }
      if (secondSave.length > 0) {
        const apiResult: ApiResult<InsertResult> = await appContext.api.saveList(listItemType, secondSave);
        if (!apiResult || !apiResult.success)
          errMsg += (errMsg ? '\n' : '') + (apiResult?.message ?? constants.SAVE_ERROR_MESSAGE);
        else {
          secondSave.forEach((x: any) => {
            const index = data.findIndex((d: any) => d.vesselName === x.vesselName);
            if (index >= 0) {
              data[index].cid = x.vesselName;
              data[index].hasBeenChanged = false;
            }
            if (x.isNew) {
              x.isNew = false;
              //delete data[index].isNew;
            }
          })
        }
      }
    }
    
    if(errMsg) {
      await showGlobalOkDialog(<p>{errMsg}</p>);
      setLoading(false);
      return;
    }
    reload(false);

    await showGlobalOkDialog(<p>The data has been saved</p>);
  }

  
  const tableOptions: ApplicableTableSettings = {
    customTableId: 'codes-vessel-name-list',
    selectable: true,
    tableName: 'vesselNameList',
    ...codesVesselNameList,
    height: `${tableHeight}px`,
    data: (data ?? []).map((x: any, i: number) => ({ ...x, indicator: (i + 1).toString(), changeLineItem: applyToLineItem })),
    rowRenderers: [
      { accessor: 'indicator' },
      { accessor: 'vesselName', EditCell: VesselNameRenderer },
      { accessor: 'country', EditCell: CountryRenderer },
      { accessor: 'vesselFlag', EditCell: VesselFlagRenderer },
      { accessor: 'lloydsCode', EditCell: LloydsRenderer },
      { accessor: 'groupName', EditCell: GroupRenderer },
    ],
    getCellData: (accessor: any, rowData: any, rowIndex: number): CellData | undefined => {
      if (accessor === 'vesselName')
        return { type: TableCellTypes.Text, value: data[rowIndex].vesselName  };
      else if (accessor === 'country')
       return { type: TableCellTypes.Text, value: data[rowIndex].country, align: TableCellAligns.Center };
      else if (accessor === 'vesselFlag')
        return { type: TableCellTypes.Text, value: data[rowIndex].vesselFlag, align: TableCellAligns.Center};
      else if (accessor === 'lloydsCode')
        return { type: TableCellTypes.Text, value: data[rowIndex].lloydsCode, align: TableCellAligns.Center};
      else if (accessor === 'groupName')
        return { type: TableCellTypes.Text, value: data[rowIndex].groupName, align: TableCellAligns.Center};
      else
        return undefined;
    },
    isCellLock: (accessor: string, rowData: any): boolean => {
      if(!(listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel))
        return true
      else
        return false;
    },
    orderBy: [orderBy],
    onHeaderClick,
    useEditControls: (listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel),
    //useTableHelperText: (listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel),
  };

  //const canSelectForNew = ei === -1;
  const canBeAdd = listSec?.grantAdd;

  return (
    <div style={{ marginTop: '40px' }}>
      <Portal node={document && document.getElementById('settings-command-placeholder')}>
        <div style={{display:'flex', width: '100px' }}>
          <div className="ifms-common-bar-element-center">
            <GreenButton size="regular" disabled={loading} onClick={save}><span style={{ textDecoration: 'underline' }}>S</span>ave</GreenButton>
          </div>
          <div style={{ margin: 'auto' }}></div>
          <div className="ifms-common-bar-element-center">
            <CloseButton onlyIcon name='settings-close' mode='light' onClick={refContext.cancel} />
          </div>
        </div>
      </Portal>
      <div style={{ display: 'flex', width: '864px' }}>
        <div style={{ marginLeft: 'auto' }}></div>

        <div style={{ position: 'relative', top: '-4px' }}>
          <div style={{ display: 'none' }}>
            <FilterButton /> &nbsp;&nbsp;
          </div>
          {/* <BlackInverseButton name='list-screen-refresh' size="large" disabled={loading} onClick={() => { reload(true); }} data-tooltip="Refresh" >
            <FontAwesomeIcon color='#47C83E' icon={faSync} />
          </BlackInverseButton> */}
          <RefreshIconButton2 name='list-screen-refresh' onClick={() => { reload(true); }} disabled={loading} data-tooltip="Refresh"/>
        </div>
      </div>
      <div style={{ width: '864px'}}>
      <EditableTable
        initializeFocusedCell={focusFirstCell}
        tableOptions={tableOptions}
        deleteLine={deleteEntity}
        addLine={addLineItem}
        canDeleteRow={rowNumber => listSec?.grantDel??false}
      />
    </div>
    {/* 250721.inhyung.issue#2570. Table 하단에 text 추가. */}
    <div style={{ marginTop: '6px', fontSize: '14px', color: '#000000' }}>
      To add item, press "Insert" Key in any row.<br />
      To delete item, press "Delete" Key on selected row.
    </div>
    </div>
  );
}

export default VesselNameComponent;
